/**
 * ★ 2026-10-21 — Card Indonesia dell'hub (IT/ES/EN), condivise.
 * Richiesta cliente: «card proporzionate e migliorate, soprattutto Bali».
 *   • stessa larghezza delle card Albania (max-w-3xl, 2 colonne), altezze UGUALI (flex + CTA in fondo)
 *   • cover con proporzione fissa 16/10 (niente altezze in px) + object-position per il ritaglio pulito
 *     (Villa Flora: solo locandine → ritaglio piscina/villa senza testo · Lombok: foto aerea senza testo)
 *   • fatti concreti (chip) invece di un solo claim; testi passati dalla pagina (lingua)
 *   • evento `cta_click` (label hub_indonesia_card) per misurare il routing
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, MapPin } from 'lucide-react';
import { trackFunnelEvent, withUtm } from '../../lib/attribution';

export function IndonesiaAssetCards({ cards, tokens, ctaLabel, testIdPrefix = 'ital-id', funnel = 'it', className = '' }) {
  const { gold, ivory, sand, emerald } = tokens;
  const onClick = (c, where) => trackFunnelEvent('cta_click', { funnel, label: 'hub_indonesia_card', target: c.href, slug: c.slug, where });
  return (
    <div className={`mt-8 grid grid-cols-1 sm:grid-cols-2 gap-5 max-w-3xl ${className}`} data-testid={`${testIdPrefix}-cards`}>
      {cards.map((c) => {
        const href = withUtm(c.href);
        return (
          <article
            key={c.slug}
            className="group rounded-2xl border overflow-hidden flex flex-col h-full transition-transform duration-200 hover:-translate-y-0.5"
            style={{ borderColor: `${gold}55`, background: `${emerald}CC` }}
            data-testid={`${testIdPrefix}-card-${c.slug}`}
          >
            <Link to={href} onClick={() => onClick(c, 'cover')} aria-label={`${c.name} — ${ctaLabel}`} className="block relative aspect-[16/10] overflow-hidden">
              <img
                src={c.cover} alt={c.name}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-300 group-hover:scale-[1.04]"
                style={{ objectPosition: c.coverPosition || 'center' }}
                loading="lazy"
              />
              <span className="absolute inset-x-0 bottom-0 h-20" style={{ background: 'linear-gradient(180deg, rgba(8,23,18,0) 0%, rgba(8,23,18,0.78) 100%)' }} aria-hidden="true" />
              <span className="absolute left-4 bottom-3 inline-flex items-center gap-1.5 text-[10px] font-sans font-bold tracking-[0.25em] uppercase" style={{ color: gold }}>
                <MapPin className="w-3 h-3" aria-hidden="true" /> {c.place}
              </span>
            </Link>
            <div className="p-5 sm:p-6 flex flex-col flex-1">
              <h3 className="text-xl sm:text-2xl uppercase tracking-wide leading-tight" style={{ color: ivory }}>{c.name}</h3>
              <p className="mt-2 text-sm font-sans leading-relaxed" style={{ color: sand }}>{c.tagline}</p>
              {c.facts?.length > 0 && (
                <ul className="mt-3 flex flex-wrap gap-1.5" aria-label={`${c.name} — facts`}>
                  {c.facts.map((f) => (
                    <li key={f} className="rounded-full border px-2.5 py-1 text-[11px] font-sans font-semibold" style={{ borderColor: `${gold}55`, color: ivory }}>{f}</li>
                  ))}
                </ul>
              )}
              <Link
                to={href} onClick={() => onClick(c, 'cta')}
                className="mt-auto pt-5 block"
                data-testid={`${testIdPrefix}-card-cta-${c.slug}`}
              >
                <span className="w-full rounded-full min-h-11 px-4 text-[11px] font-sans font-bold tracking-[0.2em] uppercase inline-flex items-center justify-center gap-2 transition-transform duration-150 hover:scale-[1.02] text-center leading-snug" style={{ background: ivory, color: '#143C2B', boxShadow: `0 0 0 1px ${gold}` }}>
                  {ctaLabel} <ArrowRight className="w-3.5 h-3.5 shrink-0" />
                </span>
              </Link>
            </div>
          </article>
        );
      })}
    </div>
  );
}
